module.exports = __webpack_public_path__ + "static/img/introduction-planet-barometer-hero.f21cb84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-planet-barometer-hero.jpg
// module id = vjjy
// module chunks = 0